// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"cR-z","inlineTitle":"dR-z","sponsoredAdsWrapper":"eR-z","marketplaceRecosWrapper":"fR-z"};